import React from 'react'

// icons : feather
import FeatherIcon from 'feather-icons-react';

export default function SingleList(props) {
    // props
    const {
        dataItem,
        handleDropdownExpand,
        handleValueChange,

        openedListIds,

        selectedCategoryOption
    } = props

    // variables
    let multiLevelCategories = null

    // if the category has sub items
    if (dataItem?.subCats?.length) {
        multiLevelCategories = (
            <React.Fragment>
                {
                    dataItem.subCats.map(item => {
                        return (
                            // sub menu
                            <div key={item.id} className="sub-menu" data-value={dataItem.name}>
                                <SingleList
                                    dataItem={item}

                                    handleDropdownExpand={(ev, id) => handleDropdownExpand(ev, id)}
                                    handleValueChange={handleValueChange}

                                    openedListIds={openedListIds}

                                    selectedCategoryOption={selectedCategoryOption}
                                />
                            </div>
                        )
                    })
                }
            </React.Fragment>
        )
    }

    return (
        <div
            className={`item cursor-pointer d-block ${dataItem?.subCats?.length ? "has-sub-category" : ""} ${openedListIds.find(oitem => oitem === dataItem.id) ? "expanded" : ""}`}
            data-value={dataItem.name}
        >
            <label className="item-inner d-block st-fw-400 cursor-pointer">
                <input
                    type="radio"
                    className="d-none"
                    value={dataItem.name}
                    checked={selectedCategoryOption === dataItem.name}
                    onChange={handleValueChange}
                />
                {/* lt */}
                <span className="lt d-inline-block">
                    {
                        (dataItem?.subCats?.length) ? ( // if sub categories exists only show the icon then
                            <button className="st-round-btn st-btn-primary st-btn-xs d-flex align-items-center justify-content-center" onClick={ev => handleDropdownExpand(ev, dataItem.id)}>
                                <FeatherIcon
                                    icon={openedListIds.find(oitem => oitem === dataItem.id) ? "chevron-down" : "chevron-right"}
                                    size="20"
                                    className="icon position-relative" />
                            </button>
                        ) : null
                    }
                </span>

                {/* ct */}
                <span className="ct d-inline-block">
                    <p className="text">{dataItem.name}</p>
                </span>

                {/* rt */}
                <span className="rt d-inline-block">
                    <span className="round"></span>
                </span>
            </label>

            {
                openedListIds.find(oitem => oitem === dataItem.id) ? ( // toggeling visibility
                    <React.Fragment>
                        {multiLevelCategories}
                    </React.Fragment>
                ) : null
            }
        </div>
    )
}
